export const globalHTMLCanvasObjects = [];
